import type { EntityOption } from '@/components/EntitySelect';
import { getStaffInvoiceEmployee, listStaffInvoiceEmployees } from './api';

/** Employee picker for staff invoices — the finance-owned list, so Accountants
 *  (who can't read HR records) can pick too (DEV13-77). */
export async function searchStaffInvoiceEmployees(query: string): Promise<EntityOption[]> {
  const rows = await listStaffInvoiceEmployees({ search: query || undefined });
  return rows.map((e) => ({ value: String(e.id), label: e.name }));
}

export async function resolveStaffInvoiceEmployeeLabel(value: string): Promise<string | null> {
  if (!value) return null;
  return (await getStaffInvoiceEmployee(Number(value)))?.name ?? null;
}
